import Mapper from '..';
import { prepareFile } from '../../../utils/Exporter';
import InputTypes from '../../../enums/InputTypes';
import { dateToISOString } from '../../../utils/DateMixins';
import { isEmpty, isNumeric } from '../../../utils/ValidForm';

export default class SendMapper {
    #mapper;

    constructor(mapper) {
        this.#mapper = mapper;
    }

    async #getFormData(keys, data, files) {
        const formData = new FormData();
        let nObject = {};
        for (let i = 0; i < keys.length; i++) {
            if (files.length > 0 && files.filter((file) => file.name === keys[i]).length === 0) {
                nObject[keys[i]] = data[keys[i]];
            }
        }

        for (let i = 0; i < files.length; i++) {
            if (data[files[i]?.name]?.anexo) {
                data[files[i]?.name] = await prepareFile(data[files[i]?.name]);
            }
            formData.append(
                this.#mapper.getOptions()?.paramName?.files ?? 'files',
                data[files[i]?.name]
            );
        }

        if (Object.keys(nObject).length > 0) {
            formData.append(
                this.#mapper.getOptions()?.paramName?.json ?? 'json',
                new Blob([JSON.stringify(Mapper.setNullInEmpty(nObject))], {
                    type: 'application/json',
                })
            );
        }
        return { formData, nObject };
    }

    format(inputs, values, paramsPage) {
        let data = {
            ...values,
        };
        const keys = Object.keys(values);
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            const input = inputs.filter((el) => el.name === key)[0];

            if (input) {
                switch (input?.type) {
                    case InputTypes.ENTITY:
                        data[key] = isNumeric(data[key]) ? { id: data[key] } : data[key];
                        if (input?.form?.paramName) {
                            data[key] = { id: paramsPage?.[input?.form?.paramName] ?? null };
                        }
                        break;
                    case InputTypes.DATETIME:
                        if (data[key]?.constructor?.name === 'Date') {
                            data[key] = dateToISOString(data[key]);
                        }
                        break;
                    default:
                        break;
                }

                if (input?.form?.paramName && input?.type !== InputTypes.ENTITY) {
                    data[key] = paramsPage?.[input?.form?.paramName] ?? null;
                }
            }
        }
        return { keys, data };
    }

    async prepare(formController, values, paramsPage = null) {
        const inputs = formController.inputs;
        const files = inputs.filter((input) => input.type === InputTypes.FILE);
        const inputsWithParam = inputs.filter((input) => !isEmpty(input?.form?.paramName));
        for (let i = 0; i < inputsWithParam.length; i++) {
            if (!values?.[inputsWithParam[i].name]) values[inputsWithParam[i].name] = null;
        }
        const { data, keys } = this.format(inputs, values, paramsPage);

        if (files.length === 0) {
            return {
                data: Mapper.setNullInEmpty(data),
                original: data,
                completeData: data,
                config: {},
            };
        } else {
            const { formData, nObject } = await this.#getFormData(keys, data, files);
            return {
                data: formData,
                original: nObject,
                completeData: data,
                config: {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                },
            };
        }
    }
}
